import React from 'react';

import Grid, { defaultFormatters } from 'components/Grid';

import { ColumnDefinition } from 'components/Grid/types';

import { AcknowledgementStateOperator } from 'components/Grid/operators/Status';

import { DATETIME_COLUMN_MIN_WIDTH, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR, ProtectorType } from 'core/constants';

import { formatMoment } from 'utils/formatters/timezone';

import { AcknowledgementRow, AcknowledgementState } from 'utils/api/modules/entities/entities.types';

import AcknowledgementStateChip from 'components/AcknowledgementStateChip';

export const buildColumns = (): ColumnDefinition[] =>
  [
    {
      field: 'recipientName',
      headerName: 'Name',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filterable: false,
      protectorType: ProtectorType.ShortText,
      renderCell: ({ row }: { row: AcknowledgementRow }) => row.recipient?.name ?? '—',
    },
    {
      field: 'state',
      headerName: 'Status',
      width: 150,
      sortable: true,
      filterable: true,
      nativeFilter: 'state',
      filterOperators: AcknowledgementStateOperator(),
      renderCell: ({ row }: { row: AcknowledgementRow }) => (
        <AcknowledgementStateChip state={row.state as AcknowledgementState} />
      ),
    },
    {
      field: 'acknowledgedAt',
      headerName: 'Acknowledged at',
      minWidth: DATETIME_COLUMN_MIN_WIDTH,
      sortable: true,
      filterable: false,
      protectorType: ProtectorType.DateTime,
      valueFormatter: defaultFormatters.date_time,
      renderCell: ({ row }: { row: AcknowledgementRow }) =>
        row.acknowledgedAt ? (
          <span data-testid="acknowledgement-recipient-acknowledged-at">
            {formatMoment(row.acknowledgedAt, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)}
          </span>
        ) : (
          '—'
        ),
    },
    {
      field: 'tiptapVersion',
      headerName: 'Version',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: ({ row }: { row: AcknowledgementRow }) => (row.tiptapVersion != null ? `v${row.tiptapVersion}` : '—'),
    },
  ] as unknown as ColumnDefinition[];

interface RequestRecipientsGridProps {
  requestUuid: string;
  onRefreshCallback?: (callback: () => void) => void;
}

const RequestRecipientsGrid: React.FunctionComponent<RequestRecipientsGridProps> = ({
  requestUuid,
  onRefreshCallback,
}) => (
  <Grid
    basicColumns={buildColumns()}
    dataURL={`/api/entities/documents/acknowledgement-requests/${requestUuid}/acknowledgements/`}
    sortBy={{ field: 'recipientName', sort: 'asc' }}
    onRefreshCallback={onRefreshCallback}
    customNoRowsText="No recipients found"
    disableSelectAllColumns
    disableExport
  />
);

export default RequestRecipientsGrid;
